export default __webpack_public_path__ + "static/media/error-fallback.d5fcc02d.png";